module.exports = __webpack_public_path__ + "img/ma.97ae2871.png";